import React, { useState, useEffect } from "react";
import { Box, Typography, Grid } from "@mui/material";
import "./ViewCandidate.css";
import Breadcrumb from "../../Components/Breadcrumb/Breadcrumb";
import { useParams } from "react-router-dom";
import { getCandidatesData, getLeadAssignUserList } from "./ApiCalls";
import dayjs from "dayjs";
import ArrowBackIosOutlinedIcon from "@mui/icons-material/ArrowBackIosOutlined";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import { getLeadAssignUserData } from "../EditLead/ApiCalls";
import Timeline from "@mui/lab/Timeline";
import TimelineItem, { timelineItemClasses } from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";

//
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ViewCandidate = () => {
  const [ClientPersonalDetails, setClientPersonalDetails] = useState([]);
  const [ClientStatus, setClientStatus] = useState([]);
  const [leadAssignUserList, setLeadAssignUserList] = React.useState([]);
  const [comments, setComments] = React.useState([]);

  let candidateId = useParams();

  let lastlocation = useParams();

  const candidateDetailData = () => {
    getCandidatesData(candidateId)
      .then((response) => {
        // console.log(response.data);
        setComments(response.data[0].comments.split("~"));
        setClientPersonalDetails([
          { label: "Posted On", desc: response.data[0].create_dt },
          { label: "Source", desc: response.data[0].c_source },
          { label: "Candidate Name", desc: response.data[0].c_name },
          {
            label: "Mobile No.",
            desc: "+" + response.data[0].c_ccode + " " + response.data[0].c_mob,
          },
          {
            label: "Alt Mobile No.",
            desc:
              "+" +
              response.data[0].c_alt_ccode +
              " " +
              response.data[0].c_alt_mob,
          },
          //   { label: "Alternate Mobile No.", desc: '+'+response.data[0].s_ccode+' '+response.data[0].s_mob },
          { label: "Email Id.", desc: response.data[0].c_email },
          //   { label: "Alternate Email Id.", desc: response.data[0].s_email }
          { label: "Position", desc: response.data[0].c_position },
          { label: "Country", desc: response.data[0].country },
          { label: "State", desc: response.data[0].state },
          { label: "City", desc: response.data[0].city },
          { label: "Locality", desc: response.data[0].locality },
        ]);

        setClientStatus([
          { label: "Candidate Status", desc: response.data[0].c_status },
          {
            label: "Followup Date",
            desc: dayjs(response.data[0].followup_dt).format("YYYY-MM-DD"),
          },
          {
            label: "Followup Time",
            desc: dayjs(response.data[0].followup_dt).format("hh:mm A"),
          },
          { label: "Candidate Name", desc: response.data[0].c_name },
        ]);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    candidateDetailData();
  }, []);

  return (
    <>
      {/* <Breadcrumb
        PageName="View Candidate Detail"
        BackButton={[
          true,
          "Back",
          "/all-candidate",
          <ArrowBackIosOutlinedIcon />,
        ]}
      /> */}

      <Breadcrumb
        PageName="View Lead"
        BackButton={[
          true,
          "Back",
          lastlocation.lastlocation === "assigncandidates"
          ? "/assigncandidates"
          : lastlocation.lastlocation === "nonassigncandidate"
          ? "/nonassigncandidate"
          : lastlocation.lastlocation
          ? "/candidate-by-status/"
          // ? "/candidate-by-status/" + lastlocation.lastlocation
          : "/all-candidate/",
          <ArrowBackIosOutlinedIcon />,
        ]}
      />

      <Box className="custom-card">
        <Typography variant="h4" className="custom-card-head">
          View Candidate Detail Details :-
        </Typography>
        <Box p={2}>
          <Grid container spacing={2} mb={2}>
            {ClientPersonalDetails.map((details, id) => {
              return details.desc !== "" && details.desc !== "null" ? (
                <Grid item xs={12} md={6} key={id}>
                  <Box className="details-card">
                    <Typography
                      variant="span"
                      className="custom-subhead"
                      sx={{ color: "#000", fontWeight: "500", width: "30%" }}
                    >
                      {details.label}
                    </Typography>
                    <div sx={{ width: "5%" }}>-</div>
                    <Typography
                      variant="span"
                      className="custom-subhead"
                      sx={{ width: "65%", textAlign: "left" }}
                    >
                      {details.desc}
                    </Typography>
                  </Box>
                </Grid>
              ) : null;
            })}
          </Grid>
        </Box>
      </Box>
      <Box className="custom-card" mt={2} style={{ height: "300px" }}>
        <Typography variant="h4" className="custom-card-head">
          Candidate Status :-
        </Typography>
        <Box p={2}>
          <Grid container spacing={2} mb={2}>
            <Grid
              item
              xs={12}
              md={6}
              style={{ height: "201px", display: "grid" }}
            >
              {ClientStatus.map((details, id) => {
                return details.desc !== "" && details.desc !== "null" ? (
                  <Box className="details-card" key={id}>
                    <Typography
                      variant="span"
                      className="custom-subhead"
                      sx={{ color: "#000", fontWeight: "500", width: "30%" }}
                    >
                      {details.label}
                    </Typography>
                    <div sx={{ width: "5%" }}>-</div>
                    <Typography
                      variant="span"
                      className="custom-subhead"
                      sx={{ width: "65%", textAlign: "left" }}
                    >
                      {details.desc}
                    </Typography>
                  </Box>
                ) : null;
              })}
            </Grid>
            <Grid item xs={6} md={6} sx={{ position: "relative" }}>
              <Box
                sx={{
                  position: "absolute",
                  height: "201px",
                  overflowY: "auto",
                  top: "0.7rem",
                }}
              >
                <Typography variant="h6" className="custom-form-label">
                  Comments
                </Typography>
                <Timeline
                  sx={{
                    [`& .${timelineItemClasses.root}:before`]: {
                      flex: 0,
                      padding: 0,
                    },
                    margin: "0%",
                  }}
                >
                  {comments?.map((comment, i) => (
                    <TimelineItem key={i}>
                      <TimelineSeparator>
                        <TimelineDot />
                        <TimelineConnector />
                      </TimelineSeparator>
                      <TimelineContent sx={{ fontSize: "14px" }}>
                        {comment}
                      </TimelineContent>
                    </TimelineItem>
                  ))}
                </Timeline>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default ViewCandidate;
